<template>
  <div class="flex box-presenting-right items-center p-3 rounded mb-3">
    <img src="@/assets/images/elements/users-icon.svg" alt="" class="mr-2">
    <span>
      Any editor can host this presentation for <b>{{ plan.limit | formatNumber }} participants</b>
    </span>
    <aha-icon
      class="ml-1 text-base-70"
      name="question"
      viewBox="0 0 24 24"
      width="15"
      height="15"
      v-tooltip="`Because the presentation owner has <b>${plan.name}</b> plan`"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      plan: (state) => state.plan,
    }),
  },
}
</script>

<style lang="scss" scoped>
.box-presenting-right {
  background-color: #F0EBFF;
}
</style>
